module.exports = __webpack_public_path__ + "img/text-image.5354fae1.svg";